export default {
  root: ({ instance }) => {
    return {
      class: [
        "p-progressbar",
      ],
    };
  },
  value: ({ instance }) => ({
    class: [
      "p-progressbar-value",
      {
        "p-progressbar-value-black": instance.$attrs?.color === "black",
        "p-progressbar-value-amber": instance.$attrs?.color === "amber",
        "p-progressbar-value-green": instance.$attrs?.color === "green"
      }
    ]
  }),
label: () => ({
    class: 
      "p-progressbar-label",
})
};